export default __webpack_public_path__ + "static/media/element_50.bd2269f5.webp";